import { createNgModule, Inject, Injectable, Injector, NgModuleRef, Type, ViewContainerRef } from '@angular/core';
import { DYNAMIC_COMPONENT_MANIFESTS, DynamicComponentLoaderModule } from './dynamic-component-loader.module';
import { DynamicComponentManifest } from './dynamic-component-loader.types';

@Injectable({
  providedIn: DynamicComponentLoaderModule,
})
export class DynamicComponentLoaderService {

  constructor(
    @Inject(DYNAMIC_COMPONENT_MANIFESTS) private dynamicComponentManifests: DynamicComponentManifest[],
    private _injector: Injector,
  ) {
  }

  public loadSingleComponent(componentId: string, htmlContainer: ViewContainerRef, data?: any, cleanContainer?: boolean): void {
    if (htmlContainer) {

      if (cleanContainer && htmlContainer.length) {
        htmlContainer.remove(0);
      }

      const componentManifest = this.dynamicComponentManifests.find((c) => c.componentId === componentId);
      const standaloneComponent = !!componentManifest?.loadComponent;

      this.loadComponent(componentManifest, componentId, htmlContainer, data, standaloneComponent);
    }
  }

  public loadListOfComponents(components: any[], componentIdKey: string, htmlContainer: ViewContainerRef): void {
    if (htmlContainer) {
      this.asyncForEach(components, async (component) => {
        const componentManifest = this.dynamicComponentManifests.find((c) => c.componentId === component[componentIdKey]);
        const standaloneComponent = !!componentManifest?.loadComponent;
        await this.loadComponent(componentManifest, component[componentIdKey], htmlContainer, component, standaloneComponent );
      }).then();
    }
  }

  private async asyncForEach(array: any[], callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  }

  private async loadComponent(componentManifest: DynamicComponentManifest, componentId: string, htmlContainer: ViewContainerRef, data: any, standaloneComponent = false) {

    if (!componentManifest) {
      console.warn(`DynamicComponentLoaderService: Unknown componentId "${componentId}", check the manifest`);
      return;
    }

    if (standaloneComponent) {
      await componentManifest?.loadComponent()?.then((importedFile) => {
        const ref = htmlContainer.createComponent(importedFile);

        ref.instance['componentData'] = data;
        ref.changeDetectorRef.markForCheck();
      });
    } else {
      await componentManifest?.loadChildren()?.then((importedFile) => {
        const componentToOpen = importedFile.module.dynamicComponent;

        if (!componentToOpen) {
          console.warn(`DynamicComponentLoaderService: Module for "${componentId}" does not contain thee "dynamicComponent" definition`);
          return;
        }

        const module: Type<any> = (<any>importedFile.moduleRef)[Object.keys(importedFile.moduleRef)[0]];
        const moduleRef: NgModuleRef<any> = createNgModule(module, this._injector);
        const ref = htmlContainer.createComponent(componentToOpen, {ngModuleRef: moduleRef});

        ref.instance['componentData'] = data;
        ref.changeDetectorRef.markForCheck();
      });

    }
  }
}
